import React from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import { graphql } from "gatsby"
import Cover from "../components/home/Cover"
import Featured from "../components/home/Featured"
import Trending from "../components/home/Trending"
import Testimonial from "../components/home/Testimonial"

export default function IndexPage({ data, location }) {
  // console.log(data)
  return (
    <Layout>
      <Seo pathname={location.pathname} title="Home" />
      <Cover />
      <Featured data={data.properties.edges} />
      <Trending data={data.trending.edges} />
      <Testimonial data={data.testimonial.edges} />
    </Layout>
  )
}

export const query = graphql`
  query {
    testimonial: allSanityTestimonial {
      edges {
        node {
          client_country
          client_name
          client_position
          testimonial
        }
      }
    }

    trending: allSanityTrending {
      edges {
        node {
          name
          description
          cover {
            asset {
              gatsbyImageData
            }
          }
          slug {
            current
          }
        }
      }
    }

    properties: allSanityProperty {
      edges {
        node {
          name
          pool
          price
          ref
          shortDescription
          slug {
            current
          }
          status
          type
          location_name
          _rawDescription
          area
          bath
          bed
          cover {
            asset {
              gatsbyImageData
            }
          }
        }
      }
    }
  }
`
